<template>
	<v-container fill-height>
		<v-row
			align="center"
			justify="center"
		>
			<v-col
				cols="12"
				sm="8"
				md="4"
			>
				<v-card flat color="transparent">
					<h2 class="text-center mb-5">Sitio en Contrucción</h2>
					<v-img src="../../../img/web.svg" alt="sitio-web-contruccion" width="100%" />
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>
<script>
export default {
	data: () => ({
	}),
	computed: {
	},
	methods: {
	}
};
</script>
<style>
	
</style>